<section>
  <img src="/auth/boy-holding-white-paper-school.png" alt="school boy holding paper">

  <div class="container">
    <h3>Welcome</h3>

    <p>Sign in to your administrative workspace</p>

    <form #loginForm="ngForm" (ngSubmit)="login(loginForm)">
      <div>
        <label for="username">Username</label>
        <input required [(ngModel)]="username" type="text" name="username" id="username" placeholder="e.g. eattoh25">
      </div>

      <div>
        <label for="password">Password</label>
        <input required [(ngModel)]="password" type="password" name="password" id="password" placeholder="Enter your password...">
      </div>

      <div class="btn-container">
        <button [disabled]="loginForm.invalid || (password.length < 8)" type="submit" class="button">
          @if (isLoading()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Confirm
          }
        </button>
      </div>

    </form>
  </div>
</section>
